import LanguageDropdown from "./LanguageDropdown";
import { Link, useNavigate } from "react-router-dom";
import MenuMobile from "./MenuMobile";
import Cookies from "js-cookie";
import axios from "axios";
import { useEffect, useState } from "react";
import { use } from "react";

const Header2 = ({ scroll, isMobileMenu, handleMobileMenu }) => {
  const refreshToken = Cookies.get("refreshToken");
  const navigate = useNavigate();
  const [basePages, setBasePages] = useState([]);
  const [useCasePages, setUseCasePages] = useState([]);
  const location = window.location.pathname;

  const logout = () => {
    Cookies.remove("accessToken");
    Cookies.remove("refreshToken");
    navigate("/");
  };

  const fetchpages = async () => {
    const config = {
      headers: {
        "content-type": "application/json",
      },
    };
    const response = await axios.get(
      process.env.REACT_APP_BACKEND_URL + "/getpages",
      config
    );

    console.log(response.data);

    const usecasepages = response.data.use_case_pages;
    const basepages = response.data.base_pages;

    setBasePages(basepages);
    setUseCasePages(usecasepages);
  };

  useEffect(() => {
    fetchpages();
  }, []);
  return (
    <header>
      <div id="header-fixed-height" />
      <div className="header-top">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="header-top-content text-center">
                <p>
                  Sign up and receive 300 Free Credits .{" "}
                  <Link to="/signup">
                    Learn more <i className="far fa-angle-right" />
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div id="sticky-header" className="menu-area menu-area-two">
        <div className="container custom-container">
          <div className="row">
            <div className="col-12">
              <div className="mobile-nav-toggler" onClick={handleMobileMenu}>
                <i className="fas fa-bars" />
              </div>
              <div className="menu-wrap">
                <nav className="menu-nav">
                  <div className="logo">
                    <Link to="/">
                      <img src="/assets/img/logo/logo_big.png" alt="Logo" />
                    </Link>
                  </div>
                  <div className="navbar-wrap main-menu d-none d-lg-flex">
                    <ul className="navigation">
                      <li className="menu-item-has-children">
                        <Link to="/">Home</Link>
                        <ul className="sub-menu !bg-gray-100">
                          <li>
                            <Link
                              className="text-black bg-purple-300"
                              to="/about"
                              style={{ backgroundColor: "transparent" }}
                              onMouseEnter={(e) =>
                                (e.target.style.backgroundColor = "#cabffd")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.backgroundColor = "transparent")
                              }
                            >
                              About us
                            </Link>
                          </li>
                          <li>
                            <Link
                              className="text-black bg-purple-300"
                              to="/contact"
                              style={{ backgroundColor: "transparent" }}
                              onMouseEnter={(e) =>
                                (e.target.style.backgroundColor = "#cabffd")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.backgroundColor = "transparent")
                              }
                            >
                              Contact us
                            </Link>
                          </li>
                        </ul>
                      </li>

                      <li className="menu-item-has-children">
                        <Link to="/tools">AI Tools</Link>
                        <ul className="sub-menu !bg-gray-100">
                          <li>
                            {" "}
                            <Link
                              className="text-black bg-purple-300"
                              style={{ backgroundColor: "transparent" }}
                              onMouseEnter={(e) =>
                                (e.target.style.backgroundColor = "#cabffd")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.backgroundColor = "transparent")
                              }
                              to="/ai-footage-editing"
                            >
                              Footage Editing (Multilayer)
                            </Link>{" "}
                          </li>
                          <li>
                            {" "}
                            <Link
                              className="text-black bg-purple-300"
                              style={{ backgroundColor: "transparent" }}
                              onMouseEnter={(e) =>
                                (e.target.style.backgroundColor = "#cabffd")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.backgroundColor = "transparent")
                              }
                              to="/ai-footage-editing"
                            >
                              Footage Editing (Slideshow)
                            </Link>{" "}
                          </li>
                          <li>
                            {" "}
                            <Link
                              className="text-black bg-purple-300"
                              style={{ backgroundColor: "transparent" }}
                              onMouseEnter={(e) =>
                                (e.target.style.backgroundColor = "#cabffd")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.backgroundColor = "transparent")
                              }
                              to="/text-to-video"
                            >
                              Text to Video (Multilayer)
                            </Link>{" "}
                          </li>
                          <li>
                            {" "}
                            <Link
                              className="text-black bg-purple-300"
                              style={{ backgroundColor: "transparent" }}
                              onMouseEnter={(e) =>
                                (e.target.style.backgroundColor = "#cabffd")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.backgroundColor = "transparent")
                              }
                              to="/text-to-video"
                            >
                              Text to Video (slideshow)
                            </Link>{" "}
                          </li>
                          <li>
                            {" "}
                            <Link
                              className="text-black bg-purple-300"
                              style={{ backgroundColor: "transparent" }}
                              onMouseEnter={(e) =>
                                (e.target.style.backgroundColor = "#cabffd")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.backgroundColor = "transparent")
                              }
                              to="/microservices/autosubtitles"
                            >
                              Auto Subtitle Addition
                            </Link>{" "}
                          </li>
                          <li>
                            {" "}
                            <Link
                              className="text-black bg-purple-300"
                              style={{ backgroundColor: "transparent" }}
                              onMouseEnter={(e) =>
                                (e.target.style.backgroundColor = "#cabffd")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.backgroundColor = "transparent")
                              }
                              to="/microservices/backgroundremover"
                            >
                              Video Background Removal
                            </Link>{" "}
                          </li>
                          <li>
                            {" "}
                            <Link
                              className="text-black bg-purple-300"
                              style={{ backgroundColor: "transparent" }}
                              onMouseEnter={(e) =>
                                (e.target.style.backgroundColor = "#cabffd")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.backgroundColor = "transparent")
                              }
                              to="/microservices/silenceremover"
                            >
                              Auto Silence Removal
                            </Link>{" "}
                          </li>
                        </ul>
                      </li>

                      <li className="menu-item-has-children">
                        <Link to="/business-suite">Suites</Link>
                        <ul className="sub-menu !bg-gray-100">
                          <li>
                            {" "}
                            <Link
                              className="text-black bg-purple-300"
                              style={{ backgroundColor: "transparent" }}
                              onMouseEnter={(e) =>
                                (e.target.style.backgroundColor = "#cabffd")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.backgroundColor = "transparent")
                              }
                              to="/business-suite"
                            >
                              Business
                            </Link>{" "}
                          </li>
                          <li>
                            {" "}
                            <Link
                              className="text-black bg-purple-300"
                              style={{ backgroundColor: "transparent" }}
                              onMouseEnter={(e) =>
                                (e.target.style.backgroundColor = "#cabffd")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.backgroundColor = "transparent")
                              }
                              to="/suites/cinematic"
                            >
                              Cinematic
                            </Link>{" "}
                          </li>
                          <li>
                            {" "}
                            <Link
                              className="text-black bg-purple-300"
                              style={{ backgroundColor: "transparent" }}
                              onMouseEnter={(e) =>
                                (e.target.style.backgroundColor = "#cabffd")
                              }
                              onMouseLeave={(e) =>
                                (e.target.style.backgroundColor = "transparent")
                              }
                              to="/suites/marketer"
                            >
                              Marketer
                            </Link>{" "}
                          </li>
                        </ul>
                      </li>

                      <li className="menu-item-has-children">
                        <Link to="/blog">Blogs</Link>
                        <ul className="sub-menu !bg-gray-100">
                          {basePages &&
                            basePages.map((page, index) => (
                              <li key={page.id || index}>
                                <Link
                                  className="text-black bg-purple-300"
                                  style={{ backgroundColor: "transparent" }}
                                  onMouseEnter={(e) =>
                                    (e.target.style.backgroundColor = "#cabffd")
                                  }
                                  onMouseLeave={(e) =>
                                    (e.target.style.backgroundColor =
                                      "transparent")
                                  }
                                  to={`/products/${page.url}`}
                                  onClick={() => window.location.href = `/products/${page.url}`}
                                >
                                  {page.title}
                                </Link>
                              </li>
                            ))}
                          {useCasePages &&
                            useCasePages.map((page, index) => (
                              <li key={page.id || index}>
                                <Link
                                  className="text-black bg-purple-300"
                                  style={{ backgroundColor: "transparent" }}
                                  onMouseEnter={(e) =>
                                    (e.target.style.backgroundColor = "#cabffd")
                                  }
                                  onMouseLeave={(e) =>
                                    (e.target.style.backgroundColor =
                                      "transparent")
                                  }
                                  to={`/features/${page.url}`}
                                  onClick={() => window.location.href = `/features/${page.url}`}
                                >
                                  {page.title}
                                </Link>
                              </li>
                            ))}
                        </ul>
                      </li>

                      <li>
                        <Link to="/profilepage">Profile</Link>
                      </li>
                    </ul>
                  </div>
                  <div className="header-action d-none d-md-block">
                    <ul className="list-wrap">
                      {/* <li className="header-lang">
                        <LanguageDropdown />
                      </li> */}
                      {refreshToken ? (
                        <li className="header-btn">
                          <button onClick={() => logout()} className="btn">
                            logout
                          </button>
                        </li>
                      ) : (
                        <li className="header-btn">
                          {location !== "/login" && (
                            <Link to="/login" className="btn">
                              Log in
                            </Link>
                          )}
                        </li>
                      )}

                      {refreshToken
                        ? location !== "/schedulemeet" && (
                            <Link
                              style={{ marginLeft: "1rem" }}
                              to="/schedulemeet"
                              className="gradient-btn gradient-btn-three wow fadeInLeft"
                            >
                              Edit With Us
                            </Link>
                          )
                        : location !== "/signup" && (
                            <Link
                              style={{ marginLeft: "1rem" }}
                              to="/signup"
                              className="gradient-btn gradient-btn-three wow fadeInLeft"
                            >
                              Free Trial
                            </Link>
                          )}
                    </ul>
                  </div>
                </nav>
              </div>
              {/* Mobile Menu  */}
              <div className="mobile-menu">
                <nav className="menu-box">
                  <div className="close-btn" onClick={handleMobileMenu}>
                    <i className="fas fa-times" />
                  </div>
                  <div className="nav-logo" onClick={handleMobileMenu}>
                    <Link to="/">
                      <img src="/assets/img/logo/logo_big.png" alt="Logo" />
                    </Link>
                  </div>
                  <div className="menu-outer">
                    <MenuMobile
                      handleCloseMenu={handleMobileMenu}
                      basePages={basePages}
                      useCasePages={useCasePages}
                    />
                  </div>

                  <div className="social-links">
                    <ul className="clearfix list-wrap">
                      <li>
                        <Link to="https://twitter.com/editai_">
                          <i className="fab fa-twitter" />
                        </Link>
                      </li>
                      <li>
                        <Link to="https://www.instagram.com/editai.in">
                          <i className="fab fa-instagram" />
                        </Link>
                      </li>
                      <li>
                        <Link to="https://www.linkedin.com/in/edit-ai">
                          <i className="fab fa-linkedin-in" />
                        </Link>
                      </li>
                      <li>
                        <Link to="https://youtube.com/@_editai_">
                          <i className="fab fa-youtube" />
                        </Link>
                      </li>
                    </ul>
                  </div>
                </nav>
              </div>
              <div className="menu-backdrop" onClick={handleMobileMenu} />
              {/* End Mobile Menu */}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
export default Header2;
